import Radio from 'backbone.radio'
// @ts-expect-error TODO: Convert to TypeScript
import type ProductModel from './models/product'

/**
 * Payload of first parameter with `optionsChanged` events.
 */
export interface ProductOptionsChanged {
  quantity?: number
  trim?: ProductModel
  substrateEnumName?: string
}

export default Radio.channel('product')
